/* tslint:disable */
/* eslint-disable */
/**
 * Employees API
 * API to get company clients employees
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CompanyClientReviewLabelOfEmployee,
    CompanyClientReviewLabelOfEmployeeFromJSON,
    CompanyClientReviewLabelOfEmployeeFromJSONTyped,
    CompanyClientReviewLabelOfEmployeeToJSON,
} from './CompanyClientReviewLabelOfEmployee';

/**
 * 
 * @export
 * @interface CompanyClientEmployeeReviewCreateRequest
 */
export interface CompanyClientEmployeeReviewCreateRequest {
    /**
     * The ID of review record
     * @type {number}
     * @memberof CompanyClientEmployeeReviewCreateRequest
     */
    reviewId?: number;
    /**
     * Review score of this employee
     * @type {number}
     * @memberof CompanyClientEmployeeReviewCreateRequest
     */
    reviewScore: number;
    /**
     * Employee ID
     * @type {number}
     * @memberof CompanyClientEmployeeReviewCreateRequest
     */
    employeeId: number;
    /**
     * Shift ID for which the review is given
     * @type {number}
     * @memberof CompanyClientEmployeeReviewCreateRequest
     */
    shiftId: number;
    /**
     * Already chosen labels for this review
     * @type {Array<CompanyClientReviewLabelOfEmployee>}
     * @memberof CompanyClientEmployeeReviewCreateRequest
     */
    labels: Array<CompanyClientReviewLabelOfEmployee>;
    /**
     * Additional notes after on review
     * @type {string}
     * @memberof CompanyClientEmployeeReviewCreateRequest
     */
    note?: string;
    /**
     * Is employee favored by Company Client
     * @type {boolean}
     * @memberof CompanyClientEmployeeReviewCreateRequest
     */
    favourite: boolean;
}

export function CompanyClientEmployeeReviewCreateRequestFromJSON(json: any): CompanyClientEmployeeReviewCreateRequest {
    return CompanyClientEmployeeReviewCreateRequestFromJSONTyped(json, false);
}

export function CompanyClientEmployeeReviewCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyClientEmployeeReviewCreateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reviewId': !exists(json, 'reviewId') ? undefined : json['reviewId'],
        'reviewScore': json['reviewScore'],
        'employeeId': json['employeeId'],
        'shiftId': json['shiftId'],
        'labels': ((json['labels'] as Array<any>).map(CompanyClientReviewLabelOfEmployeeFromJSON)),
        'note': !exists(json, 'note') ? undefined : json['note'],
        'favourite': json['favourite'],
    };
}

export function CompanyClientEmployeeReviewCreateRequestToJSON(value?: CompanyClientEmployeeReviewCreateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reviewId': value.reviewId,
        'reviewScore': value.reviewScore,
        'employeeId': value.employeeId,
        'shiftId': value.shiftId,
        'labels': ((value.labels as Array<any>).map(CompanyClientReviewLabelOfEmployeeToJSON)),
        'note': value.note,
        'favourite': value.favourite,
    };
}

